import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'in0052',
    ecrans: ['00-2'],
    params: ['id']
});
